import { render, staticRenderFns } from "./StepBox.vue?vue&type=template&id=7c01be16&scoped=true"
import script from "./StepBox.vue?vue&type=script&lang=js"
export * from "./StepBox.vue?vue&type=script&lang=js"
import style0 from "./StepBox.vue?vue&type=style&index=0&id=7c01be16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01be16",
  null
  
)

export default component.exports